import { useMutation } from '@tanstack/react-query';
import { userService } from '../../services/userService';

export const useRequestChangeEmail = () => {
  return useMutation({
    mutationFn: payload =>
      userService.requestChangeEmail(payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return { success: true, error: null };
        }
        return { success: false, error: data.message };
      }),
  });
};
